import { createContext } from 'react';

export interface StepNav {
  onNext?: () => void | Promise<void>;
  canGoNext?: boolean;
  nextLabel?: string;
  nextIcon?: string | null;
  hideNext?: boolean;
  showPrevious?: boolean;
  onPrevious?: () => void;
  previousLabel?: string;
  previousIcon?: string | null;
}

export type StepNavSetter = (nav: StepNav | null) => void;

export const StepNavContext = createContext<StepNavSetter | null>(null);

// Wraps each step's content. Lets useRegisterStepNav skip registration when the
// step is inactive — slide/keepAlive animations keep every step mounted, so
// without this gate every step's useEffect would fight to publish its nav.
export const StepActiveContext = createContext<boolean>(false);
